import React from 'react';

import PropTypes from 'prop-types';
import { Modal } from 'react-bootstrap-5';
import ShowcaseContactForm from './form';

function ShowcaseContactModal({ show, onAddContact, onClose }) {
  return (
    <Modal show={show} onHide={onClose}>
      <Modal.Header closeButton>
        <Modal.Title>Add/Edit Showcase Contact</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <ShowcaseContactForm onAddContact={onAddContact}/>
      </Modal.Body>
    </Modal>
  );
}

ShowcaseContactModal.propTypes = {
  show: PropTypes.bool.isRequired,
  onAddContact: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired
};

export default ShowcaseContactModal;
